

// aici poti sa schimbi textul pentru servicii de pe pagina lor dedicata

const services = [
    {
      title: "Consultanță privind Utilizarea Inteligenței Artificiale",
      content: [
        "Evaluarea impactului AI: Analiză detaliată a impactului inteligenței artificiale asupra proceselor interne și administrative.",
        "Dezvoltarea unei strategii AI: Crearea unui plan personalizat pentru integrarea responsabilă și eficientă a AI.",
        "Implementare practică: Suport tehnic pentru implementarea soluțiilor bazate pe AI.",
        "Conformitate legală: Verificarea respectării reglementărilor naționale și europene privind AI."
      ],
    },
    {
      title: "Servicii de Training",
      content: [
        "Training în domeniul securității datelor: Instruire pentru angajați, conform standardelor internaționale (ISO/IEC 42001).",
        "Workshop-uri personalizate: Sesiuni interactive pentru alinierea la cerințele actuale în securitatea și protecția datelor.",
        "Program dedicat pentru whistleblowing: Instruire pentru implementarea și utilizarea mecanismelor de raportare etică.",
        "Ghiduri și materiale suport: Documentație completă pentru facilitarea aplicării cunoștințelor dobândite."
      ],
    },
    {
      title: "Consultanță privind Breșele de Securitate a Datelor",
      content: [
        "Identificarea riscurilor: Evaluarea vulnerabilităților în sistemele de securitate.",
        "Gestionarea incidentelor: Asistență în investigarea și remedierea breșelor de securitate.",
        "Notificarea autorităților: Suport pentru respectarea cerințelor legale privind raportarea incidentelor.",
        "Consolidarea măsurilor de securitate: Recomandări și implementări pentru prevenirea incidentelor viitoare."
      ],
    },
    {
      title: "Consultanță în Prelucrarea Datelor cu Caracter Personal",
      content: [
      
        "Evaluarea Riscurilor de Securitate: Identificăm și evaluăm riscurile de securitate cibernetică pentru instituții guvernamentale.",
        "Implementarea Măsurilor de Securitate: Oferim recomandări și implementăm măsuri eficiente pentru protecția datelor.",
        "Protecție sporită împotriva amenințărilor cibernetice și reducerea vulnerabilităților."
      ],
    },
    {
      title: "Consultanță în Implementarea Standardelor de Whistleblowing",
      content: [
        "Evaluare și strategie: Identificarea nevoilor organizației și crearea unui plan de implementare.",
        "Dezvoltarea mecanismelor de raportare: Soluții eficiente și sigure pentru sesizări.",
        "Training pentru personal: Instruire specifică pentru utilizarea sistemelor de whistleblowing.",
        "Monitorizare și îmbunătățire: Suport pentru optimizarea proceselor de raportare."
      ],
    },
    {
      title: "Consultanță în Privacy și ePrivacy",
      content: [
        "Analiză detaliată: Evaluăm conformitatea organizației cu reglementările de confidențialitate.",
        "Optimizarea măsurilor existente: Recomandăm îmbunătățiri pentru protejarea datelor personale.",
        "Implementare practică: Suport pentru alinierea la standardele de ePrivacy.",
        "Asistență continuă: Monitorizare și sprijin în menținerea conformității.",
        "Promovarea încrederii: Creăm un mediu digital sigur și transparent pentru utilizatori."
      ],
    },
  ];
  
  export default services;
  